import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccess } from '@/lib/session';
import { PLAN_LABEL, hasFeature, requiredTierFor } from '@/lib/access';

/* Visible-but-gated wrapper. When the current plan can't reach the feature's
   tier (runtime-aware via superadmin Feature Control), render an upgrade
   prompt instead of the page content. */
export default function RequireTier({ feature, children }: { feature: string; children: ReactNode }) {
  const access = useAccess();
  const navigate = useNavigate();

  // hasFeature folds in the global kill switch + per-tenant overrides + tier.
  if (hasFeature(access.effectiveTier, feature)) return <>{children}</>;
  const required = requiredTierFor(feature) ?? 'pro';

  return (
    <div className="p-6">
      <div className="max-w-md mx-auto mt-12 text-center bg-background-50 border border-background-200 rounded-xl p-8">
        <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-50 flex items-center justify-center">
          <i className="ri-lock-2-line text-2xl text-accent-500"></i>
        </div>
        <h2 className="text-lg font-bold text-foreground-800">Upgrade to {PLAN_LABEL[required]}</h2>
        <p className="text-sm text-foreground-500 mt-2">
          This feature is part of the <span className="font-medium text-foreground-700">{PLAN_LABEL[required]}</span> plan.
          Upgrade to unlock it for your outlet.
        </p>
        <button
          onClick={() => navigate('/dashboard/billing')}
          className="mt-5 px-5 py-2 text-sm font-semibold rounded-lg bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors cursor-pointer"
        >
          View plans
        </button>
      </div>
    </div>
  );
}
